// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z1mU","textarea":"styles_textarea__-53p5"};